import styled from 'styled-components'

import { fonts, palette } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { MIXPANEL_PROPS, Mixpanel } from '../../utils/mixpanel'

const LinkContainer = styled.button({
  padding: 14,
  display: 'flex',
  flexDirection: 'column',
  textDecoration: 'none',
  color: 'inherit',
  ':visited': {
    color: 'inherit',
  },
  ':focus': {
    color: 'inherit',
  },
  fontSize: '13px',
  lineHeight: '16px',
  cursor: 'pointer',
  outline: 'none',
  border: 'none',
  background: 'transparent',
  textAlign: 'left',
  ':hover': {
    color: 'inherit',
    background: palette.gray10,
    h4: {
      color: palette.orange,
    },
    p: {
      color: palette.darkGray,
    },
  },
})

const Title = styled.h4({
  fontFamily: fonts.primaryBold,
  fontSize: '16px',
  lineHeight: '22.4px',
  margin: 0,
})

const Paragraph = styled.p({
  margin: '8px 0px 0px 0px',
  fontSize: '12px',
  lineHeight: '18px',
  color: palette.darkGray70,
})

const Link = ({
  title,
  description,
  href,
  mixPanelMenuSubItemName,
  mixPanelButtonLocation,
}) => (
  <div>
    <LinkContainer
      data-href={href}
      onClick={() => {
        Mixpanel.trackNPDConsultingClick({
          [MIXPANEL_PROPS.MENU_SUBITEM_NAME.name]: mixPanelMenuSubItemName,
          [MIXPANEL_PROPS.BUTTON_LOCATION.name]: mixPanelButtonLocation,
        })

        window.open(href, '_blank')
      }}
    >
      <Title>{translate(title)}</Title>
      <Paragraph>{translate(description)}</Paragraph>
    </LinkContainer>
  </div>
)

export default Link
